import { render, staticRenderFns } from "./DashboardProdutos.vue?vue&type=template&id=3c4d3b6a"
import script from "./DashboardProdutos.vue?vue&type=script&lang=js"
export * from "./DashboardProdutos.vue?vue&type=script&lang=js"
import style0 from "./DashboardProdutos.vue?vue&type=style&index=0&id=3c4d3b6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports